export default __webpack_public_path__ + "static/media/postman.52856718.svg";